export default {
    namespaced: true,
    state:{
      access_token: null,
      link_url: null,
      user_data: [],
      status_permission: null,
    },
    mutations:{
      login_success(state, data) {
          state.access_token = data.access_token;
          state.user_data    = data.user_data;
          state.status_permission  = data.status_permission;
      },
      logout_success(state) {
          state.access_token = null;
          state.user_data = null;
          state.status_permission = null;
      },
    }
}